import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { setTeacherCredentials } from '../../slices/teachers/authTeacherSlice';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import axios from "axios";

const TeacherPaymentCallback = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    useEffect(() => {
        if (teacherInfo) {
          axios.post("/api/teacherpayments/paymentstatus").then((res) => {
            dispatch(setTeacherCredentials({ ...res.data }));  
            navigate('/teacherrevenue')
          });
        }
      }, [teacherInfo]);

  return (
<div>
    <TeacherNavbar />
      <div className="main-content" id="panel">
      <TeacherHeader /><br /><br /><br /><br /><br />
        <div className="container-fluid mt--6">
          <div className="row">
            <div className="col-xl-8 offset-xl-2">  
              <div className="card-wrapper profileCard">
                    <div className="card"> <br />
                    <Loader />
                    </div>      
                </div>      
            </div>      
          </div>      
        </div>      
    </div>
    </div>
  )
}

export default TeacherPaymentCallback
